const popularProduct = {
	tab : $('.js-poppulaProductTabs__tab'),
	selectTab(id) {
		this.tab.removeClass('current');
		$(`.js-poppulaProductTabs__tab[data-id="${id}"]`).addClass('current');
	}
	
}
$(document).on('click', '.js-poppulaProductTabsButton', function() {
	$('.js-poppulaProductTabsButton').removeClass('current');
	$(this).addClass('current');
	if ($(this).hasClass('current')) {
		popularProduct.selectTab($(this).data('tab-id'));
	}
});
